webpackJsonp([6],{

/***/ "./src/pages/go/go-video.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/pages/go/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./src/pages/go/index.scss");

__webpack_require__("./src/pages/go/go-video.scss");

var videos = "",
    videosArray = [];
jQuery(document).ready(function ($) {
    videos = $('#set-desc-videoValue').val().trim();
    videosArray = videos.split("|");
    $('#setup_support_goButton').click(function () {
        var url = "https://support.caavo.com/hc/en-us/categories/360000849312-Installation-and-Setup-Information";
        window.open(url, '_blank');
    });
    $('.faq-block').hover(function () {
        $(this).toggleClass("go_faq_border");
    });
    $('#slick-setup-videos').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $("#span_yt_player_" + videosArray[currentSlide]).attr('src', $("#span_yt_player_" + videosArray[currentSlide]).attr('src'));
    });
});

/***/ }),

/***/ "./src/pages/go/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["./src/pages/go/index.js"]);